<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>


    <div v-show="!modoView">
        <div class="form-edit-page row row-space">
            <div class="form-item-rangedata"><DateRangeSelect :periodoInicial="'currentMonth'" v-model="dateRange" /></div>
            
            <div class="form-item">
                <EquipamentoFrame v-model:objSelecionado="equipamentoSelecionado"/>
            </div>

            <div class="form-item-char30">
                <label class="label-caption">Situação</label>
                <select v-model="cdStatus">
                    <option :value="0">TODAS</option>
                    <option v-for="s in lsStatus" :key="s.cdstatus" :value="s.cdstatus">{{ s.nmstatus }}</option>
                </select>
            </div>

            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>

        <div v-if="lsDados.length > 0">
            <div class="table-wrapper"><table>
                <thead><tr>
                    <th>OS</th>
                    <th>Nome/Identificação</th>
                    <th>Equipamento</th>
                    <th>Placa</th>
                    <th>Fornecedor</th>
                    <th>Abertura</th>
                    <th>Status</th>
                </tr></thead>

                <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="editarCadastro(obj)"
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}"
                >
                    <td class="col-width-char10 right">{{ Funcoes.formatInteger(obj.cdos) }}</td>
                    <td>{{ obj.nmos }}</td>
                    <td class="col-width-char30">{{ obj.nmequipamento }}</td>
                    <td class="col-width-char10 center">{{ obj.placa }}</td>
                    <td class="col-width-char30">{{ obj.nmfornecedor }}</td>
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtabertura) }}</td>
                    <td class="col-width-char30">{{ obj.nmstatus }}</td>
                </tr></tbody>
            </table></div>

            <div v-if="showPagination" class="pagination">
                <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
                <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
                <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
            </div>
        </div>
    </div>

    <div v-if="modoView">
        <ManutOsViewPage :idView="idView" @close="modoView = false" />
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import EquipamentoFrame from '@/components/frames/EquipamentoFrame.vue';
import ManutOsViewPage from '../views/ManutOsViewPage.vue';

const emit = defineEmits(['close']);

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const idView = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const modoView = ref(false);
const msgAlerta = ref(null);
const equipamentoSelecionado = ref();

const cdStatus = ref(0);
const lsStatus = ref([
    { cdstatus: 1, nmstatus: 'DIGITAÇÃO' },
    { cdstatus: 2, nmstatus: 'ORÇAMENTO' },
    { cdstatus: 3, nmstatus: 'APROVAÇÃO' },
    { cdstatus: 4, nmstatus: 'EXECUÇÃO' },
    { cdstatus: 5, nmstatus: 'ENCERRADA' },
]);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

function closeForm() { emit('close'); }

function editarCadastro(obj) {
    idView.value = obj.id;
    modoView.value = true;
}


function updatePaginatedData() {
    const startIndex = (currentPage.value - 1) * globalStore.itensPorPagina;
    const endIndex = (startIndex + globalStore.itensPorPagina);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


async function lerDados() {
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const payload = {
            idmunicipio: globalStore.idmunicipio,
            idequipamento: equipamentoSelecionado.value?.id,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate,
            intparam1: cdStatus.value,
            idlogin: globalStore.idlogin,
        };

        const req = await Api.genericPost('/dados/manut_os', payload);
        lsDadosMain.value = req || [];
        currentPage.value = 1;
        showPagination.value = (lsDadosMain.value.length > globalStore.itensPorPagina);
        updatePaginatedData();
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}

onMounted(lerDados);
</script>
